export default "__VITE_ASSET__CKw_mStd__"